import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { CUSTOM_ELEMENT_DEFAULT, PROGRAM_CLI_MOVIES_ITEMS } from '../../../constants/state'
import EditNewspaperElement from '../../PageEditItem/present/EditNewspaperElement'
import { addNewspaperItem, printDataUpdateRequest } from '../../../actions'
import getData from '../../../functions/getData'
import getMovieSortedByTitle from '../../../functions/getMoviesSortedByTitle'
import { CUSTOMITEMS } from '../../../constants/itemTypes'

const mapDispatchToProps = (dispatch, ownProps) => ({
    addNewspaperItem: (item) => {
        dispatch(addNewspaperItem(item, 'customItemsNew'))
        dispatch(printDataUpdateRequest())
    }
})

const mapStateToProps = state => ({
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS)
})

const AddCustomItemsContainer = ({addNewspaperItem, itemType, closePagePath, cinemaId, movieData}) => (
    <EditNewspaperElement
        closePagePath={closePagePath}
        itemType={itemType}
        cinemaId={cinemaId}
        movieData={movieData}
        itemData={CUSTOM_ELEMENT_DEFAULT}
        onUpdateItem={addNewspaperItem}
        sortedMovieDataKeys={getMovieSortedByTitle(movieData)}
    />
)

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(AddCustomItemsContainer)